import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DragulaModule } from 'ng2-dragula';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { ChipModule } from 'primeng/chip';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';
import { BurtUiModule } from '@burt-ui';

import { DragDropListComponent } from './components/drag-drop-list/drag-drop-list.component';
import { ItemGroupFoldoutComponent } from './components/item-group-foldout/item-group-foldout.component';
import { MetricFiltersComponent } from './components/metric-filters/metric-filters.component';
import { MetricFiltersModalComponent } from './components/metric-filters-modal/metric-filters-modal.component';
import { PropertiesListComponent } from './components/properties-list/properties-list.component';
import { QueryBuilderComponent } from './components/query-builder/query-builder.component';
import { QueryBuilderModalComponent } from './components/query-builder-modal/query-builder-modal.component';
import { QueryFiltersComponent } from './components/query-filters/query-filters.component';

import { DropdownMultiSelectModule } from '../../components/dropdown-multi-select/dropdown-multi-select.module';
import { DirectivesModule } from '../../directives/directives.module';


export { QueryBuilder } from './query-builder';

const COMPONENTS = [
  DragDropListComponent,
  PropertiesListComponent,
  QueryBuilderComponent,
  ItemGroupFoldoutComponent,
  QueryBuilderModalComponent,
  QueryFiltersComponent,
  MetricFiltersModalComponent,
  MetricFiltersComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DragulaModule.forRoot(),
    ReactiveFormsModule,
    BurtUiModule,
    DropdownMultiSelectModule,
    DirectivesModule,
    DialogModule,
    ButtonModule,
    SelectModule,
    InputNumberModule,
    TooltipModule,
    MessageModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    DatePickerModule,
    MultiSelectModule,
    ChipModule,
    SelectButtonModule,
  ],
  declarations: [COMPONENTS],
  exports: [COMPONENTS],
})
export class QueryBuilderModule {}
